export default __webpack_public_path__ + "static/media/icon-risk.a6129eb1.svg";